/** Shared, DOM-free closed controls for the two additive authoring reads. */
export type RecapCollectionControls = { limit?: number; cursor?: string | null };
export type GoalChoiceControls = RecapCollectionControls & { player_ids: string[] };

function closed(value: unknown, keys: readonly string[]): void {
  if (!value || typeof value !== 'object' || Array.isArray(value)
    || Object.keys(value).some(key => !keys.includes(key))) throw new RangeError('invalid_authoring_query');
}

function page(value: RecapCollectionControls) {
  const limit = value.limit ?? 20;
  if (!Number.isSafeInteger(limit) || limit < 1 || limit > 50
    || (value.limit !== undefined && value.limit === null)) throw new RangeError('invalid_authoring_query');
  const cursor = value.cursor ?? null;
  if (cursor !== null && (typeof cursor !== 'string' || cursor.length < 1 || cursor.length > 128)) {
    throw new RangeError('invalid_authoring_query');
  }
  return { limit, cursor };
}

export function normalizeCoachRecapQuery(value: RecapCollectionControls = {}) {
  closed(value, ['limit','cursor']);
  return page(value);
}

export function normalizeAuthoringGoalQuery(value: GoalChoiceControls) {
  closed(value, ['player_ids','limit','cursor']);
  if (!Array.isArray(value.player_ids) || value.player_ids.length < 1 || value.player_ids.length > 50
    || value.player_ids.some(id => typeof id !== 'string' || [...id].length < 1 || [...id].length > 200)
    || new Set(value.player_ids).size !== value.player_ids.length) throw new RangeError('invalid_authoring_query');
  return { player_ids: [...value.player_ids].sort(), ...page(value) };
}
